import React from 'react';
import Flagship from '../../core/flagship';
import {Link} from 'react-router';
import moment from 'moment';
import { Button, Feed, Label, Loader, Segment, Icon } from 'semantic-ui-react';

class NeedPricing extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = this.getInitialState();

    }

    // Separate component state for UI only
    getInitialState() {
        return {
            offset: 0,
            items: [],
            error: '',
            loading: false
        }
    }

    componentDidMount() {
        this.getFeedItems();
    }

    componentWillUnmount() {
        this.interval = null;
    }

    getFeedItems() {
        this.setState({
            loading:true
        });

        let self = this;

        Flagship.get(
            'rfps-due/',
            {
                limit:8
            },
            function(response) {
                if (response.data.success === true ) {

                    self.setState(
                        {
                            items:  response.data.results,
                            loading: false

                        });
                } else {

                    self.setState(
                        {
                            error: "Failed to load RFPs in need of pricing.",
                            loading: false
                        }
                    );
                }
            }
        );

    }


    getMessage(action) {
        if ( Flagship.config.possibleActions.hasOwnProperty(action) ) {
            return Flagship.config.possibleActions[action]
        }
        return '';
    }


    render() {

        return (
            <div className="fade-in">
                <Feed>
                    {this.state.error !== '' ? this.state.error : ''}

                    {typeof this.state.items !== "undefined" && this.state.items.length > 0 ? this.state.items.map(function(item, i) {
                        
                        let dueLabel = null;

                        if ( typeof item.extra3 !== "undefined" && item.extra3 !=="" ) {
                            let fromUnix = moment.unix(parseInt(item.extra3) + 64800 ); // add 18 hours in seconds to make due at 6pm Eastern
                            let fromNow = fromUnix.fromNow();
                            let dayDiff = moment().diff(fromUnix, "days");
                            let dueColor = "grey";
                            if (dayDiff >= 1) {
                                dueColor = "red";
                            } else if (dayDiff === 0) {
                                dueColor = "orange";
                            } else if (dayDiff === -1) {
                                dueColor = "yellow";
                            } else if (dayDiff < -1 && dayDiff > -7) {
                                dueColor = "blue";
                            }
                            dueLabel = <Label color={dueColor}>Due {fromNow}</Label>;
                        }
                        return (
                           <Feed.Event key={"feed-item-" + i}>
                               <Feed.Content>
                                   <Feed.Extra text>
                                       <Link className="single-dash-widget-record" to={'/' + item.record_type + '/view/' + item.record_key}>
                                       <Segment>
                                           <h3>
                                               <Icon className="feed-icon" disabled size="large" color="grey" name="dollar" />
                                               {'#' + item.record_key + ' - ' + item.record_name}
                                           </h3>
                                           <Icon name="user" color="grey" />
                                           <em><strong>DBS:</strong> {item.extra2}</em><br/>
                                           <div className="due-date">
                                               {typeof item.extra3 !== "undefined" && item.extra3 !=="" ?
                                                   dueLabel : null }
                                           </div>
                                       </Segment>
                                       </Link>
                                   </Feed.Extra>
                               </Feed.Content>
                           </Feed.Event>
                        )
                    }) : <div className="white-text">We didn't find any RFPs in need of pricing.</div>}
                </Feed>
                <Link to="/rfps?status=publish&orderby=due">
                    <Button className="view-all-button" icon="caret right" content="View all RFPs that need pricing" />
                </Link>

                <span>&nbsp;</span>&nbsp;
                {this.state.loading === true ? <Loader className="flagship-loader" active={this.state.loading} inline /> : null }
            </div>
        );
    }
}
export default NeedPricing;





// WEBPACK FOOTER //
// ./src/components/dashboard/NeedPricing.js